import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../constants/styles';
const { LOGIN_BG_COLOR } = constants;

let styles = {
  base: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    backgroundColor: LOGIN_BG_COLOR
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/containers/login/Login.styles.js